import React, { useState } from 'react'
import { useSiteContext } from '@contexts/MkSiteContext'
import { ZinIcon, ZinTooltip } from '@tnl/zin-react'
import { PROFILE_TOOLTIP_BUTTON_LABEL, PROFILE_TOOLTIP_TEXT } from '@constants'
import { UserInitialsAvatar } from '@shared/components/UserInitialsAvatar/UserInitialsAvatar'
import Card from '@components/ui/Card/Card'
import { getProfileAvatarCardProps } from './profileAvatarCardConfig'
import './ProfileAvatar.scss'

interface ProfileAvatarProps {
  name: string
}

const ProfileAvatar: React.FC<ProfileAvatarProps> = ({ name }) => {
  const { themeBrand: brand } = useSiteContext()
  const [showTooltip, setShowTooltip] = useState(false)

  const profileCardProps = getProfileAvatarCardProps(brand)

  const body = (
    <>
      <div
        role="button"
        tabIndex={0}
        aria-label={PROFILE_TOOLTIP_BUTTON_LABEL}
        aria-expanded={showTooltip}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            setShowTooltip(!showTooltip)
          }
        }}
        className="mk-profile__tooltip-trigger"
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
      >
        <ZinIcon
          name="info-circle"
          set="fal"
          size="small"
          aria-hidden
        />
      </div>

      <UserInitialsAvatar
        variant="profile"
        fullName={name}
      />
      <h2 className="mk-profile__name subtitle-1">{name}</h2>
    </>
  )

  return (
    <>
      <div className="mk-profile__avatar-container">
        {brand === 'sir' && <div className="mk-profile__avatar-background" />}
        {profileCardProps ? (
          <Card {...profileCardProps}>{body}</Card>
        ) : (
          <div className="mk-profile__avatar-box">
            {body}
          </div>
        )}
        <div className="mk-profile__tooltip-container">
          <ZinTooltip
            open={showTooltip}
            placement="top"
            alignment="middle">
            {PROFILE_TOOLTIP_TEXT(brand)}
          </ZinTooltip>
        </div>
      </div>
    </>
  )
}

export default ProfileAvatar
